// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.not-item[data-v-50feed66]{\n    margin-bottom: 3px;\n    border: 0;\n    cursor: pointer;\n}\n.no-not-msg[data-v-50feed66]{\n    border: 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
